import * as api from '@/api';
import { getBrowserSessionData } from '@/utils/browser-storage';
import { parseJwt } from '@/utils/format'

export async function getUserBySessionId({commit}, sessionId) {
    try {
        const user = await api.userAuth.getUser(sessionId)
        const userData = {
            identityKey: user.data.identityKey,
            sessionToken: user.data.sessionToken,
        }
        commit('setUser', userData);
    } catch(error) {
        console.error(error);
    }
}

export async function getUserSession({commit}, sessionId) {
    try {
        const sessionData = await api.userAuth.getUserSessionData(sessionId)
        commit('setSessionData', sessionData.data)
    } catch (error) {
        console.error(error)
    }
}

export async function getUserLocationAddress({commit}, coordinates) {
    try {
       const response =  await api.location.getClosestLocation(coordinates.lon, coordinates.lat);
       const responseData = {
           comment: response.data.data[0].comment,
           name: response.data.data[0].name,
           highlight: response.data.data[0].highlight,
           lat: response.data.data[0].lat,
           lon: response.data.data[0].lon,
       }
       commit('setUserLocationAddress', responseData);
    } catch(error) {
        console.error(error)
    }
}

export async function loginWithPassword({commit,getters}, data) {
    try {
        const scope = getters.appConfig.maRequestedScopes
        const response = await api.userAuth.loginWithPassword(data.username, data.password, scope)
        if(response?.data) {
            commit('setSessionData', response.data)

            const userData = await parseJwt(response.data.id_token)
            if(userData) {
                commit('setUser', userData);
            }
        }
        return true
    } catch(error) {
        console.error(error);
        return false
    } 
}

export async function loginWithNTLM({commit,getters}) {
    try {
        const scope = getters.appConfig.maRequestedScopes
        const response = await api.userAuth.ntlmLogin(scope)
        commit('setSessionData', response.data)

        const userData = await parseJwt(response.data.id_token)
        if(userData) {
            commit('setUser', userData);
        }
    } catch(error) {
        console.error(error);
    } 
}

export async function checkIfLoggedIn({commit}) {
    const refreshToken = getBrowserSessionData('refrToken')
    if(refreshToken) {
        try {
            const response = await api.userAuth.refreshUserSessionData(refreshToken)
            commit('setSessionData', response.data)

            const userData = await parseJwt(response.data.id_token)
            if(userData) {
                commit('setUser', userData);
            }
        } catch(error) {
            console.error(error)
            commit('setSessionData', false)
        }
    }
}
